export const AUTO_TRIED_BIOMETRIC_LOGIN_SESSION_KEY = 'autoTriedBiometricLogin';
